export default "__VITE_ASSET__DpU_9Yuz__"